export default "__VITE_ASSET__3c2611cc__"